import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface Parceiro {
  id: string;
  nome: string;
  logo_url: string;
  categoria: string | null;
  descricao_curta: string | null;
  site_url: string | null;
  ordem_exibicao: number;
  ativo: boolean;
  created_at: string;
}

export const useParceiros = () => {
  return useQuery({
    queryKey: ["parceiros"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("parceiros")
        .select("*")
        .eq("ativo", true)
        .order("ordem_exibicao");
      if (error) throw error;
      return data as Parceiro[];
    },
  });
};
